//#region Imports

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastMessageOptions } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ToastService } from './service/toast.service';
import { IconComponent } from '../icon/icon.component';

//#endregion

@Component({
  selector: 'l-toast',
  templateUrl: './toast.component.html',
  standalone: true,
  imports: [
    IconComponent
  ]
})
export class ToastComponent implements OnInit, OnDestroy {

  //#region Constructor

  constructor(
    public readonly toastService: ToastService
  ) {}

  //#endregion

  //#region Public Properties
  
  public messages: ToastMessageOptions[] = [];

  //#endregion

  //#region Private Properties

  private sub!: Subscription;

  //#endregion

  //#region Public Methods

  public ngOnInit(): void {
    this.sub = this.toastService.messages$.subscribe(msgs => {
      this.messages = msgs;
    });
  }

  public ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  public close(id: number): void {
    this.toastService.remove(id);
  }

  //#endregion

}
